// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"381":"41e09c9c","453":"e268ba49"}[chunkId] + ".chunk.js";
};